// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f3f7978a","239":"21aa864d","455":"a431b416","488":"94ed7a50"}[chunkId] + ".chunk.js";
};